import { gql } from "@apollo/client";

export const GET_MIS_TAREAS_PAGINATED = gql`
query GetMisTareas(
    $idEstado: Int!,
    $fechaDesde: CustomDateTime!,
    $fechaHasta: CustomDateTime!,
    $skip: Int
    $take: Int  
) {
    misTareas(idEstado: $idEstado, fechaDesde: $fechaDesde, fechaHasta: $fechaHasta, skip: $skip, take: $take )
    {
        items {
            idMisTareas
            idDatosGeneralesRI      
            idProfesional
            fechaLimite
            tieneAdjuntos
            idEstado
            fechaEstado
            idDatosGeneralesRINavigation {
              idPaciente
              idPacienteNavigation {
                nombre
                apellido
              }
              tipoModuloRI {                  
                  idTipoModulo   
                  idTipoModuloNavigation {
                    abreviacion
                  }                                
              }
              estadoGeneralRI {
                idEstado
                fecha
              }
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}`;